// In-app browsers (Instagram, Facebook, LinkedIn, the Google app and others):
// the mic may not work there (UNKNOWN until test T34), so the check-in offers
// "Open in Safari or Chrome" first (design 7.8). The owner can still continue.
import { useState } from "react";
import { isAndroid } from "../device";
import type { ConsultStrings } from "../strings";

/** An Android intent link that opens the same page in Chrome. */
export function chromeIntentUrl(href: string): string {
  const url = new URL(href);
  return `intent://${url.host}${url.pathname}${url.search}#Intent;scheme=${url.protocol.replace(":", "")};package=com.android.chrome;end`;
}

export function InAppBrowserNotice({
  s,
  userAgent,
  onDismiss,
}: {
  s: ConsultStrings;
  userAgent: string;
  onDismiss: () => void;
}) {
  const [copied, setCopied] = useState<"yes" | "no" | null>(null);
  const href = typeof window !== "undefined" ? window.location.href : "";
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(href);
      setCopied("yes");
    } catch {
      setCopied("no");
    }
  };
  return (
    <section className="oo-inapp" role="region" aria-labelledby="oo-inapp-title">
      <h2 id="oo-inapp-title">{s.inApp.title}</h2>
      <p>{s.inApp.body}</p>
      <div className="oo-inapp__actions">
        {isAndroid(userAgent) ? (
          <a className="oo-inapp__primary" href={chromeIntentUrl(href)}>
            {s.inApp.openChrome}
          </a>
        ) : (
          <p className="oo-inapp__steps">{s.inApp.iosSteps}</p>
        )}
        <button type="button" onClick={() => void copy()}>
          {s.inApp.copyLink}
        </button>
        <button type="button" className="oo-inapp__plain" onClick={onDismiss}>
          {s.inApp.continueAnyway}
        </button>
      </div>
      {copied === "yes" && (
        <p role="status" className="oo-inapp__copied">
          {s.inApp.copied}
        </p>
      )}
      {copied === "no" && <p className="oo-inapp__copied">{href}</p>}
    </section>
  );
}
